module.exports = __webpack_public_path__ + "media/images/diy/purple_lantern_uplighting-7207548a4318270ae7aa38ac83671f17.png";